import React from 'react';
import { useTranslation } from 'react-i18next';
import ServiceDetail from '../components/ServiceDetail';
import mdgImage from '../assets/mdg.png';
import './MDGImplementation.css';

const MDGImplementation = () => {
  const { t } = useTranslation();
  const serviceData = t('serviceContent.mdgImplementation', { returnObjects: true });

  return (
    <div className="mdg-implementation-page">
      <ServiceDetail serviceData={serviceData} serviceImage={mdgImage} serviceKey="mdgImplementation" />
    </div>
  );
};

export default MDGImplementation;



